import {
    SENDING_EMAIL,
    SEND_EMAIL_DONE,
    SEND_EMAIL_FAIL,
    OPEN_MODAL_EMAIL,
    CLOSE_MODAL_EMAIL,
    CHANGE_EMAIL_MODAL_ATTR,
    OPEN_COMPARISON_ACCORDION,
    CHANGE_EMAIL_COLLAPSE_ATTR,
    OPEN_MODAL_QUOTATION_DATE_WARNING,
    CLOSE_MODAL_QUOTATION_DATE_WARNING,
    FETCH_COMPARISON_PRODUCTS_COVERAGE,
    SET_USER_DETAILS,
    GET_INFOS_PROSPECT,
    OPEN_MODAL_QUOTATION_DATE_YEAR,
    CLOSE_MODAL_QUOTATION_DATE_YEAR,
} from '../actions/actionTypes'
import { groupByCategory } from '../utils'


export const comparison = (state = {}, action) => {
    switch (action.type) {
        case FETCH_COMPARISON_PRODUCTS_COVERAGE:
            return ({
                ...state,
                comparisonPlansInfo: action.plansInfo.map(
                    (plan) => ({
                        ...plan,
                        benefits: plan ? groupByCategory(plan.benefits) : []
                    })
                ),
            })
        case OPEN_COMPARISON_ACCORDION:
            return ({
                ...state,
                openedBenefitCode: state.openedBenefitCode !== action.code ? action.code : '',
            })
        case OPEN_MODAL_EMAIL:
            return {
                ...state,
                isModalEmailActive: true,
            }
        case CLOSE_MODAL_EMAIL:
            return {
                ...state,
                isModalEmailActive: false,
                emailStatus: ''
            }
        case SENDING_EMAIL:
            return {
                ...state,
                emailStatus: action.status,
            }
        case SEND_EMAIL_DONE:
            return {
                ...state,
                emailStatus: action.status,
            }

        case SEND_EMAIL_FAIL:
            return {
                ...state,
                emailStatus: action.status,
            }
        case CHANGE_EMAIL_MODAL_ATTR:
            return {
                ...state,
                emailModal: {
                    ...state.emailModal,
                    [action.name]: action.value,
                }
            }
        case CHANGE_EMAIL_COLLAPSE_ATTR:
            return {
                ...state,
                emailCollapse: {
                    ...state.emailCollapse,
                    [action.name]: action.value,
                }
            }
        case OPEN_MODAL_QUOTATION_DATE_WARNING:
            return {
                ...state,
                isModalQuotationDateWarningActive: true,
            }
        case CLOSE_MODAL_QUOTATION_DATE_WARNING:
            return {
                ...state,
                isModalQuotationDateWarningActive: false,
            }
        case SET_USER_DETAILS:
            return {
                ...state,
                userDetails: action.userDetails
            }
        case GET_INFOS_PROSPECT:
            if(action.infos){
                return {
                    ...state,
                    prospect: action.infos
                }
            }
            return state
        case OPEN_MODAL_QUOTATION_DATE_YEAR:
            return {
                ...state,
                isModalQuotationDateYearActive: true,
            }
        case CLOSE_MODAL_QUOTATION_DATE_YEAR:
            return {
                ...state,
                isModalQuotationDateYearActive: false,
            }
        default:
            return state;
    }
}

export default comparison



// WEBPACK FOOTER //
// ./src/reducers/comparisonReducer.js